
import $global from 'stores/global'
import $chats from 'stores/chats'
import $profile from 'stores/profile'

export default {
  props: {
    item: {type: Object, required: true},
    mode: {type: String, required: true},
  },
  emits: ['chat'],
  computed: {
    action_title() {
      return this.item.action.title || 'Chat about it'
    }
  },
  methods: {
    async onChat() {
      const chat_query = {mode: 'fast', ...this.item.action.chat_query} 
      const chat = await $chats.newChat(chat_query, $profile.chat_type)
      $global.goToChat(chat.id)
    },
    async onSuggestion(sg) {
      const chat_query = {mode: 'fast', ...sg.chat_query} 
      const chat = await $chats.newChat(chat_query, $profile.chat_type)
      $global.goToChat(chat.id)
    }
  }
}
